import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SignUpForm.scss";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";

const SignUpForm = ({ setIsAuth }) => {
  const navigate = useNavigate();

  const [signupSuccess, setSignupSuccess] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [showPassword, setShowPassword] = useState(false);
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const emailInputRef = useRef(null);

  // ------------------------------
  // 新規登録処理
  // ------------------------------
  const handleSignUp = async (e) => {
    e.preventDefault();

    const email = e.target.email.value.trim();
    const password = e.target.password.value;

    // --- 入力チェック ---
    if (!email) {
      alert("メールアドレスを入力してください。");
      return;
    }

    if (!password) {
      alert("パスワードを入力してください。");
      return;
    }

    if (password !== passwordConfirmation) {
      alert("パスワードが一致しません。");
      return;
    }

    if (
      password.length < 6 ||
      password.length > 15 ||
      !/[a-z]/.test(password) ||
      !/\d/.test(password)
    ) {
      alert("パスワードは6〜15文字で、英語の小文字と数字を含めてください。");
      return;
    }

    // --- Firebase Auth 登録 ---
    try {
      await createUserWithEmailAndPassword(auth, email, password);

      setSignupSuccess(true);

      // カウントダウン後にログイン画面へ
      let counter = 5;
      setCountdown(counter);

      const interval = setInterval(() => {
        counter -= 1;
        setCountdown(counter);

        if (counter === 0) {
          clearInterval(interval);
          navigate("/emaillogin");
        }
      }, 1000);
    } catch (error) {
      console.error("signup error:", error);

      if (error.code === "auth/email-already-in-use") {
        alert("このメールアドレスはすでに使用されています。");
      } else if (error.code === "auth/invalid-email") {
        alert("無効なメールアドレスです。");
      } else if (error.code === "auth/weak-password") {
        alert("パスワードが弱すぎます。");
      } else {
        alert(error.message || "登録中にエラーが発生しました。");
      }
    }
  };

  // ------------------------------
  // UI
  // ------------------------------
  return (
    <div className="signup-container">
      <div className="signup-content">
        {!signupSuccess ? (
          <form onSubmit={handleSignUp}>
            <div className="signup-form">
              <button
                type="button"
                className="signup-close-button"
                onClick={() => navigate("/login")}
              >
                ×
              </button>
              <p>新規登録</p>
            </div>

            <div className="signup-form">
              <p>メールアドレス</p>
              <input
                className="signup-input-email"
                name="email"
                type="email"
                ref={emailInputRef}
                required
              />
            </div>

            <div className="signup-form">
              <p>パスワード</p>
              <label className="signup-lubi">
                6〜15文字で英語の小文字と数字を含むもの
              </label>
              <input
                className="signup-input-password"
                name="password"
                type={showPassword ? "text" : "password"}
                required
              />
            </div>

            <div className="signup-form">
              <p>パスワード再確認</p>
              <input
                className="signup-input-password"
                type="password"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                required
              />
            </div>

            <div className="signup-form">
              <button className="signup-submit-button" type="submit">
                <span className="signup-form-text">新規登録</span>
              </button>
            </div>
          </form>
        ) : (
          <div className="signup-success-message">
            <p>
              <span className="signup-form-text">登録が成功しました！</span>
            </p>
            <p>
              <span className="signup-form-text">
                {countdown}秒後にログインページへ移動します…
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignUpForm;
